import React, { useEffect, useRef } from 'react';

export default function VendorBadge({ tier }) {
  const badgeRef = useRef(null);

  useEffect(() => {
    if (tier !== 'elite') return;
    const el = badgeRef.current;
    if (!el) return;
    const interval = setInterval(() => {
      const p = document.createElement('div');
      p.className = 'elite-vendor-particle';
      const dx = (Math.random() - 0.5) * 36;
      const dy = -(Math.random() * 40 + 10);
      p.style.setProperty('--dx', dx + 'px');
      p.style.setProperty('--dy', dy + 'px');
      p.style.left = (25 + Math.random() * 30) + 'px';
      p.style.top = (10 + Math.random() * 40) + 'px';
      p.style.width = (1 + Math.random() * 2.5) + 'px';
      p.style.height = p.style.width;
      el.appendChild(p);
      setTimeout(() => p.remove(), 1500);
    }, 35);
    return () => clearInterval(interval);
  }, [tier]);

  const config = {
    starter: { icon: '🪵', label: 'Starter' },
    pro: { icon: '⚡', label: 'Pro' },
    elite: { icon: '💎', label: 'Elite' },
  };

  const c = config[tier || 'starter'];
  if (!c) return null;

  return (
    <div className={`membership-badge badge-vendor-${tier || 'starter'}`} ref={badgeRef}>
      <div className="membership-badge-ring">
        <div className="membership-badge-inner">{c.icon}</div>
      </div>
      <div className="membership-badge-label">{c.label}</div>
    </div>
  );
}
